<template>
  <div :style="cmpColor">
  <span v-html="valor"></span>
  </div>
</template>
<script>
import mixinGridComponenteCelda from "@/mixins/GridComponenteCelda.js"

export default {
  name: "CeldaPickcolor",
  mixins: [mixinGridComponenteCelda],
  data() {
    return {
    }
  },
  computed: {
    cmpColor(){
      return { 'background-color' : `${this.valor}`}
    }
  },
};

</script>

<style lang="scss" scoped>
.boton-mas{
  color: blue; //#62BFD8
}
</style>
